import React from "react";
import { ArrowRightIcon, ChevronDownIcon, PhoneIcon } from "lucide-react";
import { firm, navGroups } from "../../data/site";
import { actionClass } from "../../utils/actionStyles";
import { SiteLink } from "../SiteLink";
type MobileMenuProps = {
  id: string;
  onNavigate: () => void;
};
export function MobileMenu({
  id,
  onNavigate
}: MobileMenuProps) {
  return <div id={id} className="mobile-menu absolute inset-x-0 top-full overflow-y-auto overscroll-contain border-t border-line bg-white shadow-lg nav:hidden" data-id="element-107" data-mp="15ks6j8i8cm42">
      <nav aria-label="Main" className="page-container py-3" data-id="element-108" data-mp="19ngfrhauvv1k">
        <div className="divide-y divide-line border-y border-line" data-id="element-109" data-mp="vn5qgip72oii">
          {navGroups.map(group => <details key={group.id} className="group" data-id="element-110" data-mp="10micx2c5ltkk">
              <summary className="flex min-h-[60px] cursor-pointer list-none items-center justify-between gap-4 py-4 text-label font-bold text-ink [&::-webkit-details-marker]:hidden" data-id="element-111" data-mp="2q0dm2ckzv457">
                <span data-id="element-112" data-mp="2ux41cxoz5vpk">{group.label}</span>
                <ChevronDownIcon aria-hidden="true" className="h-5 w-5 shrink-0 group-open:rotate-180" data-id="element-113" data-mp="138xqog5k2zhg" />
              </summary>
              <ul className="divide-y divide-line border-t border-line pl-3" data-id="element-114" data-mp="ya4i9254lyo5">
                {group.links.map(link => <li key={link.path} data-id="element-115" data-mp="1c3vmpw402sd0">
                    <SiteLink path={link.path} onClick={onNavigate} className="flex min-h-[52px] items-center justify-between gap-4 py-3 text-label font-semibold text-ink hover:text-crimson" data-id="element-116" data-mp="181ien11s6id2">
                      <span data-id="element-117" data-mp="tc2sjyd7313p">{link.label}</span>
                      <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-slate" data-id="element-118" data-mp="tcuoxbem92v1" />
                    </SiteLink>
                  </li>)}
              </ul>
            </details>)}
        </div>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-119" data-mp="1zrvijag658yg">
          <SiteLink path="/#case-review" onClick={onNavigate} className={actionClass("call", "w-full sm:w-auto")} data-id="element-120" data-mp="1ztpwg4t0w0t1">
            Free Case Review
          </SiteLink>
          <a href={firm.phoneHref} className={actionClass("call", "w-full sm:w-auto")} data-id="element-121" data-mp="12bz71rfzudjg">
            <PhoneIcon aria-hidden="true" className="h-5 w-5" data-id="element-122" data-mp="16fyl83dsx09n" />
            Call {firm.phoneDisplay}
          </a>
        </div>
      </nav>
    </div>;
}